import { API, METHODS } from "../../../shared/constants";
import { ISocialLink } from "../../../shared/interfaces";
import { request } from "../../../shared/utils";

export default {
    createSocialLink: (payload: ISocialLink) => request(METHODS.POST, API.CONTACTS.CREATE_SOCIAL_LINK)(payload),
    getSocialLinks: () => request(METHODS.GET, API.CONTACTS.SOCIAL_LINKS)(),
    updateSocialLinks: (payload: ISocialLink) => request(METHODS.POST, API.CONTACTS.SOCIAL_LINKS)(payload),
    deleteSocialLink: (payload: object) => request(METHODS.POST, API.CONTACTS.DELETE_SOCIAL_LINK)(payload)
};